import { combineReducers } from 'redux';
import {
  SET_IS_ELIGIBLE_FRESH,
  SHOW_MODAL_FRESH,
  HIDE_MODAL_FRESH,
} from 'actions/fresh/constants';
import createReducer from 'utils/createReducer';

const isEligible = createReducer(false, {
  [SET_IS_ELIGIBLE_FRESH]: (draft, { payload }) => payload.isEligible,
});

const showModal = createReducer(false, {
  [SHOW_MODAL_FRESH]: () => true,
  [HIDE_MODAL_FRESH]: () => false,
});

export default combineReducers({
  isEligible,
  showModal,
});
